document.addEventListener('DOMContentLoaded', function() {
  const zoomTriggers = document.querySelectorAll('.product__media-zoom-trigger');
  
  zoomTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const mediaId = this.getAttribute('data-media-id');
      const mediaItems = document.querySelectorAll('.product__media-item');
      const zoomButton = document.querySelector('.product__zoom-button');
      const carousel = document.querySelector('flickity-carousel');
      
      mediaItems.forEach(function(item) {
        item.classList.remove('is-selected');
      });
      
      const targetItem = document.querySelector(`.product__media-item[data-media-id="${mediaId}"]`);
      if (targetItem) {
        targetItem.classList.add('is-selected');
      }

      // if (carousel && carousel.flickity) {
      //   const targetIndex = Array.from(mediaItems).findIndex(item => item.getAttribute('data-media-id') === mediaId);
      //   if (targetIndex > -1) {
      //     carousel.flickity.select(targetIndex);
      //   }
      // }
      
      if (zoomButton) {
        zoomButton.click();
      }
    });
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   const zoomTriggers = document.querySelectorAll('.product__media-zoom-trigger');
  
//   zoomTriggers.forEach(function(trigger) {
//     trigger.addEventListener('click', function() {
//       const zoomButton = document.querySelector('.product__zoom-button');
//       if (zoomButton) {
//         zoomButton.click();
//       }
//     });
//   });
// });


